<template>
  <div>
    <h2 class="font-Kontesa text-[36px] font-semibold leading-[44px]">
      HOLY CRAP, {{ self!.firstName }}
    </h2>
    <p>
      You just {{ verb }}
      {{
        impactFormatter.format(
          (campaign?.dollarRatio ?? 0) *
            donation.amount *
            (self?.type === "partner" ? 0.9 : 1),
        )
      }}
      {{ unit }}!
    </p>

    <img
      class="mt-6 aspect-[2] w-full rounded-2xl border border-navy object-cover"
      aria-hidden
      :src="img"
    />

    <Separator
      class="my-6 w-full border-b border-dashed border-navy"
      orientation="horizontal"
    />

    <Button class="w-full" variant="primary-flat" @click="$emit('continue')">
      Continue
    </Button>
  </div>
</template>

<script setup lang="ts">
import { useCampaign } from "~/domains/campaigns/composables";
import { useSelf } from "~/domains/member/composables";
import { Campaign } from "~/lib/campaigns";

const props = defineProps<{
  donation: {
    campaignId: Campaign;
    amount: number;
  };
}>();
defineEmits<{ (e: "continue"): void }>();

const { donation } = toRefs(props);
const { data: self } = useSelf();

const { celebrate } = useConfettiCelebration();

onMounted(() => {
  celebrate();
});

const verb = computed(() => {
  switch (donation.value.campaignId) {
    case Campaign.TFTF:
      return "planted";
    case Campaign.OVI:
    case Campaign.PF:
    case Campaign.CLEANHUB:
      return "removed";
    case Campaign.SARTHAK:
      return "funded";
    case Campaign.REEFGEN:
      return "planted";
    default:
      throw new Error("Invalid campaign");
  }
});

const unit = computed(() => {
  switch (donation.value.campaignId) {
    case Campaign.TFTF:
      return "trees";
    case Campaign.OVI:
    case Campaign.PF:
    case Campaign.CLEANHUB:
      return "lbs of plastic";
    case Campaign.SARTHAK:
      return "days of education";
    case Campaign.REEFGEN:
      return "seagrass seeds";
    default:
      throw new Error("Invalid campaign");
  }
});

const img = computed(() => {
  switch (donation.value.campaignId) {
    case Campaign.TFTF:
      return "/images/campaigns-page/forest-gallery/img-3.jpeg";
    case Campaign.OVI:
      return "/images/campaigns-page/ocean-voyages/gallery/img-2.png";
    case Campaign.PF:
      return "/images/campaigns-page/plastic-fischer/gallery/img-5.png";
    case Campaign.SARTHAK:
      return "/images/campaigns-page/yellow-rooms/gallery/img-3.png";
    case Campaign.CLEANHUB:
      return "/images/campaigns-page/cleanhub/waste-sorters.jpg";
    case Campaign.REEFGEN:
      return "/images/campaigns-page/reefgen/gallery/img-1b.png";
    default:
      throw new Error("Invalid campaign");
  }
});

const { campaign } = useCampaign(() => donation.value.campaignId);

const impactFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});
</script>
